__turbopack_context__.v({
  "block": "landing-module__dM5n-G__block",
  "floatingContact": "landing-module__dM5n-G__floatingContact",
  "landing": "landing-module__dM5n-G__landing",
  "page-progress": "landing-module__dM5n-G__page-progress",
  "panel": "landing-module__dM5n-G__panel",
  "panelGroup": "landing-module__dM5n-G__panelGroup",
  "panelHelp": "landing-module__dM5n-G__panelHelp",
  "panelHelpCta": "landing-module__dM5n-G__panelHelpCta",
  "panelHelpPhone": "landing-module__dM5n-G__panelHelpPhone",
  "panelHelpText": "landing-module__dM5n-G__panelHelpText",
  "scrollProgress": "landing-module__dM5n-G__scrollProgress",
});
